module.exports = __webpack_public_path__ + "img/海报.368fc626.png";